const SvgQuestionCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.827}
      d="M12 13.285v-.256c0-.828.511-1.267 1.023-1.62.499-.34.998-.779.998-1.583 0-1.12-.901-2.021-2.021-2.021s-2.022.901-2.022 2.021M11.995 16.195h.01"
    />
  </svg>
);
export default SvgQuestionCircleIcon;
